(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ProfileService', ProfileService);

  ProfileService.$inject = ['$q', '$http', 'API_URI'];

  function ProfileService($q, $http, API_URI) {

    var dataPromise;

    return {
      getProfileInfo: getProfileInfo
    };

    function getProfileInfo() {
      if (angular.isUndefined(dataPromise)) {
        dataPromise = $http.get(API_URI + 'api/profile-info').then(function (result) {
          if (result.data.activeProfiles) {
            var response = {};
            response.activeProfiles = result.data.activeProfiles;
            response.ribbonEnv = result.data.ribbonEnv;
            response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
            response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
            return response;
          }
        });
      }
      return dataPromise;
    }
  }
})();
